import Container from "components/Library/Container";
import Image from "components/Library/Image";
import { Link } from "react-router-dom";

const ErrorNotFound = () => {
  return (
    <Container className="content home">
      <figure className="image__container">
        <Image
          alt="Terra Castilla logo"
          className="image image--project-logo"
          src={require("assets/img/project_logo.png")}
        />
      </figure>
      <div className="home__menu">
        <h1 className="title">404 - Página no encontrada</h1>
        <Link className="button button--secondary" to="/">
          Volver al menú
        </Link>
      </div>
      <a href="https://perspektiva360.com/" target="_blank" rel="noreferrer">
        <Image
          alt="Developed by Perspektiva360 logo"
          className="image image--developer-logo"
          src={require("assets/img/developer_logo.png")}
        />
      </a>
    </Container>
  );
};

export default ErrorNotFound;
